import { useState, useEffect } from 'react'
import { MdInfo } from 'react-icons/md'
import { icons } from 'assets/icons'
import { DistanceFromYou } from './DistanceFromYou'
import { ReportProfile } from './ReportProfile/ReportProfile'
import { ProfilePriceContainer } from '../../common/ProfilePriceContainer'
import { ProfileCTAButton } from '../ProfileCTAButton'
import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import ShareButton from 'cwp-components/ShareButton'
import { useFavourites } from 'common/hooks/useFavourites'
import { useParams } from 'react-router-dom'
import { MemberEntityTypeKey } from 'common/types/MemberProfile'

interface ProfileHeaderRightProps {
  profile: MemberProfileExtendedType
  reloadProfile?: () => void
}

export function ProfileHeaderRight({ profile, reloadProfile }: ProfileHeaderRightProps) {
  const { memberEntity } = useParams<{ memberEntity: MemberEntityTypeKey }>()
  const [showInfoPopup, setShowInfoPopup] = useState(false)
  const [isFavourite, setIsFavourite] = useState(false)
  const [heartIcon, setHeartIcon] = useState(icons.light.heart)
  const { setFavourite, isFavouriteProcessing } = useFavourites()

  useEffect(() => {
    const isFav = profile?.core?.is_favourite || false
    setIsFavourite(isFav)
    setHeartIcon(isFav ? icons.blue.heart : icons.light.heart)
  }, [profile])

  const handleFavouriteClick = async () => {
    if (isFavouriteProcessing) return

    try {
      const key =
        memberEntity === 'solicitor' || memberEntity === 'lawyer'
          ? 'lawyers'
          : memberEntity === 'chamber'
            ? 'chambers'
            : memberEntity === 'lawfirm'
              ? 'lawfirm'
              : 'barristers'

      await setFavourite(key, profile?.metadata?.id)
      setIsFavourite((prev) => !prev)
      setHeartIcon(isFavourite ? icons.light.heart : icons.blue.heart)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <div className='h-fit relative flex md:gap-4 justify-start -mt-4'>
        <DistanceFromYou
          className='flex max-lg:hidden lg:mt-1'
          distance={profile.metadata.distance}
          reloadProfile={reloadProfile}
        />
        <ReportProfile profile={profile} className='flex max-lg:hidden' />
        <div className='flex flex-col gap-3 md:gap-4'>
          <div className='flex flex-row gap-2 md:gap-4 justify-end'>
            <MdInfo
              color='#001A3D'
              className='h-4 w-4 md:h-6 md:w-6'
              onMouseEnter={() => setShowInfoPopup(true)}
              onMouseLeave={() => setShowInfoPopup(false)}
            />
            <ShareButton
              colorSVG='#001A3D'
              data={{ title: profile.displayName, url: window.location.href }}
            />
            <img
              src={heartIcon}
              className='h-4 w-4 md:h-6 md:w-6 cursor-pointer'
              alt=''
              onClick={handleFavouriteClick}
              onMouseEnter={() => setHeartIcon(icons.dark.heart)}
              onMouseLeave={() =>
                setHeartIcon(isFavourite ? icons.blue.heart : icons.light.heart)
              }
            />
            {showInfoPopup && (
              <div className='absolute top-[30px] right-[80px] bg-[#001A30] text-white text-xs rounded-lg p-4 shadow-lg w-[260px] border border-[#EBFBFF] z-10'>
                <p>
                  The information presented here is provided for general
                  informational purposes only and is sourced from third-party
                  entities. While we strive to ensure the accuracy and
                  reliability of the information provided, Legal Utopia makes no
                  representations or warranties of any kind, express or implied,
                  about the completeness, accuracy, reliability, suitability, or
                  availability of the information. Any reliance you place on
                  such information is therefore strictly at your own risk. Legal
                  Utopia assumes no responsibility or liability for any errors
                  or omissions in the content nor for any actions taken based on
                  the information provided. We encourage users to verify any
                  information independently before making decisions based on it.
                </p>
              </div>
            )}
          </div>
          <div className='md:hidden flex flex-col lg:gap-2'>
            <div className='flex justify-end'>
              <ProfileCTAButton
                className='w-[83px] h-[24px]'
                profile={profile}
              />
            </div>
            <ProfilePriceContainer hourlyRate={profile.core.hourly_rate} />
          </div>
          <DistanceFromYou
            className='flex lg:hidden justify-end'
            distance={profile.metadata.distance}
          />
        </div>
      </div>
    </>
  )
}
